WireTransferUserLimitsController.$inject = [
    '$scope',
    'usersService',
    '$filter',
    'toaster',
    'securityService',
];

export default function WireTransferUserLimitsController(
    $scope,
    usersService,
    $filter,
    toaster,
    securityService
) {
    $scope.isSuperUser = $scope.$parent.userHeader.isSuperUser;
    $scope.searchText = '';
    $scope.filteredAccountsLimits = {};
    $scope.userLimits = {};
    $scope.userLimitsPristine = {};

    $scope.reset = reset;
    $scope.search = search;
    $scope.save = save;
    $scope.setForm = setForm;
    $scope.sumCoreAccountDailyLimit = 0;

    $scope.achCompanyDailyLimitChanged = achCompanyDailyLimitChanged;
    $scope.dailyInitiationLimitChanged = dailyInitiationLimitChanged;

    function achCompanyDailyLimitChanged(frm, transLimitControlId) {
        const transLimitControl = frm[transLimitControlId];
        if (transLimitControl) {
            transLimitControl.$setDirty();
        }

        if (frm.pendingUserLimitsInitiationLimit) {
            frm.pendingUserLimitsInitiationLimit.$setDirty();
        }
    }

    function dailyInitiationLimitChanged(frm, limits) {
        if (!(limits && limits.length)) return;

        for (let i = 0; i < limits.length; i++) {
            const control = frm[`pendingDailyLimit-${i}`];
            if (control) {
                control.$setDirty();
            }
        }
    }

    function init() {
        loadUserLimits();
    }

    function save() {
        $scope.userLimits.ProductType = 'WireTransfer';

        securityService
            .verifyUser('Edit User', $scope.userLimits, () =>
                usersService.updateProductLimit($scope.id, $scope.userLimits)
            )
            .then(response => {
                if (response.success) {
                    $scope.userLimitsPristine = angular.copy($scope.userLimits);
                    $scope.$parent.notifySave();
                    $scope.form.$setPristine();
                    toaster.save('Wire User Limits');
                }
            });
    }

    function reset() {
        $scope.userLimits = angular.copy($scope.userLimitsPristine);
        search($scope.searchText);
        $scope.form.$setPristine();
    }

    function setForm(form) {
        $scope.form = form;
    }

    // Events
    function search(text) {
        $scope.searchText = text || '';
        if ($scope.userLimits !== null) {
            $scope.filteredAccountsLimits = $filter('filter')(
                $scope.userLimits.userAccountLimits,
                $scope.searchText
            );
        }
    }

    // Private
    function loadUserLimits() {
        usersService.getProductLimit($scope.id, 'WireTransfer').then(response => {
            $scope.userLimits = response;
            $scope.userLimitsPristine = angular.copy($scope.userLimits);
            sumCoreAccountDailyLimit();

            if (!$scope.userLimits.pendingUserProductLimit.approvalLimit) {
                $scope.userLimits.pendingUserProductLimit.approvalLimit =
                    $scope.userLimits.userProductLimit.approvalLimit;
            }

            if (!$scope.userLimits.pendingUserProductLimit.initiationLimit) {
                $scope.userLimits.pendingUserProductLimit.initiationLimit =
                    $scope.userLimits.userProductLimit.initiationLimit;
            }

            search('');
        });
    }

    $scope.getMinimum = function (amounts) {
        if (!Array.isArray(amounts)) {
            return amounts;
        }
        return Math.min.apply(null, amounts);
    };

    function sumCoreAccountDailyLimit() {
        if (
            !!$scope.userLimits &&
            !!$scope.userLimits.userAccountLimits &&
            $scope.userLimits.userAccountLimits.length > 0
        ) {
            $scope.sumCoreAccountDailyLimit = $scope.userLimits.userAccountLimits
                .map(limit => limit.userAccount.account.dailyLimit)
                .reduce((curr, prev) => curr + prev);
        }
    }

    $scope.getLimitForTotalDailyLimit = function () {
        if ($scope.isSuperUser) {
            return $scope.userLimits.productDailyLimit;
        }
        return $scope.getMinimum(
            $scope.sumUserPendingAccountDailyLimit(),
            $scope.userLimits.productDailyLimit
        );
    };

    $scope.sumUserPendingAccountDailyLimit = function () {
        let result = 0;
        if (
            !!$scope.userLimits &&
            !!$scope.userLimits.userAccountLimits &&
            $scope.userLimits.userAccountLimits.length > 0
        ) {
            result = $scope.userLimits.userAccountLimits
                .map(limit => limit.pendingUserAccountLimit.dailyLimit)
                .reduce((curr, prev) => curr + prev);
        }
        return result;
    };

    init();
}
